<script setup lang="ts">
interface Props {
  media: Media[]
}

defineProps<Props>()

const emit = defineEmits<{
  select: [index: number]
}>()
</script>

<template>
  <div class="h-full">
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-1">
      <button
        v-for="(item, index) in media"
        :key="item.id"
        type="button"
        class="aspect-square overflow-hidden hover:scale-102 transition-transform"
        @click="emit('select', index)"
      >
        <core-media-preview-item
          :media="item"
          :autoplay="false"
          uniform
        />
      </button>
    </div>
  </div>
</template>
